// extracted by mini-css-extract-plugin
export default {"label":"Time_label__mP+fq","asLabel":"Time_asLabel__9IBXf","input":"Time_input__ca4HG"};